import { AppName, getAppName } from 'modules/utils/ConfigUtils';

export default {
  SCREEN: {
    title: 'Link Connect Care Account'
  },
  GENERAL_ERROR: {
    severity: 'error' as 'error',
    title: `${getAppName(AppName.secondary)} Error`
  },
  EXISTING_EMAIL_ERROR: {
    severity: 'error' as 'error',
    title: `${getAppName(AppName.secondary)} Error`,
    subtitle: `${getAppName(AppName.base)} patient email is already in the ConnectCare system`
  },
  EXISTING_USER_ERROR: {
    severity: 'error' as 'error',
    title: `${getAppName(AppName.secondary)} Error`,
    subtitle: 'Login credentials for this user already exists.'
  },
  INVALID_COMBO_ERROR: {
    severity: 'error' as 'error',
    title: `${getAppName(AppName.base)} Error`,
    subtitle: 'Invalid email or password.'
  },
  INVALID_USER_ERROR: {
    severity: 'error' as 'error',
    title: `${getAppName(AppName.secondary)} Error`,
    subtitle: 'Invalid user. Please login to continue.'
  },
  LINK_ERROR: {
    severity: 'warning' as 'warning',
    title: `${getAppName(AppName.secondary)} Error`,
    subtitle:
      'Sorry, there was an issue linking your accounts. However, you can still use Connect Care during this session.'
  },
  MANUAL_LOGIN_ERROR: {
    severity: 'error' as 'error',
    title: `${getAppName(AppName.secondary)} Error`,
    subtitle: 'Could not load your Connect Care account'
  },
  SUCCESS: {
    severity: 'success' as 'success',
    title: 'Success!',
    subtitle: 'Your phone number has been updated.'
  },
  EMAIL_VALIDATION: {
    required: 'Email is required',
    invalid: 'Enter a valid email'
  },
  PASSWORD_VALIDATION: {
    required: 'Password is required'
  }
};
